import { api } from './client'
import type { ProjectCreate, ProjectListItem, ProjectOut, ProjectPatch } from '@/types'

export interface TransferGipPayload {
  gip_id: string | null
  is_substitute: boolean
}

export const projectsApi = {
  list: () => api.get<ProjectListItem[]>('/projects'),
  listDeleted: () => api.get<ProjectListItem[]>('/projects?deleted=true'),
  get:  (id: string) => api.get<ProjectOut>(`/projects/${id}`),
  create: (data: ProjectCreate) => api.post<ProjectOut>('/projects', data),
  patch:  (id: string, data: ProjectPatch) => api.patch<ProjectOut>(`/projects/${id}`, data),
  archive:  (id: string) => api.post<ProjectOut>(`/projects/${id}/archive`),
  /** Вернуть проект из архива в активные. */
  unarchive: (id: string) => api.post<ProjectOut>(`/projects/${id}/unarchive`),
  /** Перевести в стадию «Завершён» (post_design). */
  complete: (id: string) => api.post<ProjectOut>(`/projects/${id}/complete`),
  /** Мягкое удаление — перемещение в корзину. */
  deleteProject: (id: string) => api.delete(`/projects/${id}`),
  /** Восстановление проекта из корзины. */
  restoreProject: (id: string) => api.post<ProjectOut>(`/projects/${id}/restore`),
  /** Безвозвратное удаление из БД. */
  hardDeleteProject: (id: string) => api.delete(`/projects/${id}/permanent`),
  /** Передать ГИПа (постоянно или как замещающего). */
  transferGip: (id: string, data: TransferGipPayload) =>
    api.post<ProjectOut>(`/projects/${id}/transfer-gip`, data),
}
